<template>
	<div>
		<el-container style="position: absolute;left: 0;top: 0;bottom: 0;right: 0; overflow: hidden;">
		 <div style="height:50px;background:#404d5a;clear: both;" class="w-100 text-white" v-if="topInfo && sitetype=='4'">
		 	
		 	<div class="myTable mt-1 ml-1 scroll-div" style="overflow:auto;">
		 		
		 		<table v-if="this.aid!='soft10'" class="table table-dark">
		 			<tr>
		 				<th class="text-center" width="10%">[{{$t('msg.회원')}}]</th>
		 				<td>{{$t('msg.금일총입금')}} <span class="text-success">{{formatMoney(int1)}}</span> </td>
		 				<td>{{$t('msg.금일총출금')}}<span style="color:#ef9e9e">{{formatMoney(int2)}}</span></td>
		 				<td>{{$t('msg.보유머니')}} <span style="color:#ef9e9e">{{formatMoney(int3)}} </span></td>
		 				<td class="border-r">{{$t('msg.보유이벤트')}} <span class="text-success">{{formatMoney(int4)}}</span></td>
		 				<td class="pl-10">접속자 <span class="text-warning" @click="goOnline" style="cursor:pointer">{{int5}}</span></td>
		 				<td>{{$t('msg.게임머니')}} <span class="text-warning ">{{formatMoney(sitemoney)}}</span></td>
		 				<td>{{$t('msg.머니합계')}} <span class="text-warning ">{{formatMoney(ttmoney)}}</span>
							 					 <el-tooltip class="item" effect="dark" :content="$t('msg.모든회원이보유한카슬머니파워머니합계입니다')" placement="right-end">
											      <el-button icon="el-icon-warning" circle></el-button>
											    </el-tooltip>
					</td>						
		 			</tr>
		 			<tr>
		 				<th class="text-center ">[{{$t('msg.파트너')}}]</th>
		 				<td>{{$t('msg.금일총입금')}} <span class="text-success">{{formatMoney(int6)}}</span> </td>
		 				<td>{{$t('msg.금일총출금')}} <span style="color:#ef9e9e">{{formatMoney(int7)}}</span></td>
		 				<td>{{$t('msg.보유머니')}} <span style="color:#ef9e9e">{{formatMoney(int8)}}</span></td>
		 				<td class="border-r">{{$t('msg.보유이벤트')}} <span class="text-success">{{formatMoney(int9)}}</span></td>
		 				<td class="pl-10">{{moneytitle}} <span class="text-warning"><template v-if="apimoney==-1">{{$t('msg.게임사확인가능')}}</template><template v-else="">{{formatMoney(apimoney)}}</template></span> 
		 					<el-tooltip class="item" effect="dark" :content="$t('msg.본사가보유한카슬머니잔액입니다')" placement="right-end">
											      <el-button icon="el-icon-warning" circle></el-button>
						  </el-tooltip>
						</td>
		 				<td>{{$t('msg.카슬머니')}} <span class="text-warning">{{formatMoney(apiumoney)}}</span></td>
		 					<td>{{$t('msg.이벤합계')}} <span class="text-warning">{{formatMoney(int4+int9)}}</span>
		 						<el-tooltip class="item" effect="dark" :content="$t('msg.모든회원이보유한카슬롤링파워롤링합계입니다')" placement="right-end">
											      <el-button icon="el-icon-warning" circle></el-button>
						  </el-tooltip>
		 					</td>
		 			</tr>
		 		</table>

		 		<table v-if="this.aid=='soft10' " class="table table-dark">
		 			<tr>
		 				<th class="text-center" width="10%">[{{$t('msg.회원')}}]</th>
		 				<td>{{$t('msg.금일총입금')}} <span class="text-success">{{formatMoney(int1)}}</span></td>
		 				<td>{{$t('msg.금일총출금')}} <span style="color:#ef9e9e">{{formatMoney(int2)}}</span></td>
		 				<td>{{$t('msg.카슬머니')}} <span style="color:#ef9e9e">{{formatMoney(int3)}} </span></td>
		 				<td>{{$t('msg.카슬롤링')}} <span class="text-success">{{formatMoney(int4)}}</span></td>
		 			 
		 				<td class="pl-10">{{$t('msg.접속자')}}  <span class="text-warning" @click="goOnline" style="cursor:pointer">{{int5}}</span></td>
		 					<td class="pl-10">{{$t('msg.머니합계')}} <span class="text-warning"  >{{formatMoney(totalmoney)}}</span></td>
		
		 				
		 			</tr>
		 			<tr>
		 				<th class="text-center">[{{$t('msg.파트너')}}]</th>
		 				<td>{{$t('msg.금일총입금')}} <span class="text-success">{{formatMoney(int6)}}</span></td>
		 				<td>{{$t('msg.금일총출금')}} <span style="color:#ef9e9e">{{formatMoney(int7)}}</span></td>
		 				
		 	
		 				<td>{{$t('newAdd.알보유금')}} <span style="color:#ef9e9e">{{formatMoney(int8)}}</span></td>

		 				<td>{{$t('msg.카슬롤링')}}  <span class="text-success">{{formatMoney(int9)}}</span></td>
		 			
		 				
		 				<td class="pl-10">{{$t('nav.알잔액')}} <span class="text-warning" >{{formatMoney(apimoney)}}</span> <span class="text-success"   >{{formatMoney(sp_apimoney)}}</span></td>
		 				<td class="pl-10" @click="history">{{$t('msg.롤링합계')}} <span class="text-warning" >{{formatMoney(totalemoney)}}</span>
		 						<el-tooltip class="item" effect="dark" :content="$t('msg.모든회원이보유한카슬롤링파워롤링합계입니다')" placement="right-end">
											      <el-button icon="el-icon-warning" circle></el-button>
						  </el-tooltip>
		 				</td>
		 			</tr>
		 		</table>
		 	
		 		
		 	</div>
		 </div>
		  <el-header style="background:#384756;border-bottom: 1px solid #51606e;height: auto;" class="d-flex align-items-center" >


		   <a class="h5 text-light mb-0 text-center d-800" style="width:180px;">{{site}}</a> 
		   <div style="width:calc(100% - 180px);align-items: center;" class="d-flex">
		   	<div class="mr-auto d-flex d-1250" style="padding-top: 5px;">
           	<div>
           	<ul class="d-flex align-items-center" style="margin-bottom:0">
           			<li class="mr-2 display" style="cursor:pointer;padding:0 10px;">
           			
           			<div class="bg-default rounded d-flex align-items-center" style="padding:0 15px;">
           			<el-button type="text" :icon="showAside ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="showNav" style="font-size:20px !important"></el-button>
           			</div>  
           		        			
           		</li>
           		<li class="mr-2" @click="gotoMoney" style="cursor:pointer;">
           			
           			<div class="bg-default rounded d-flex align-items-center">
           				<div style="padding:0 3px;border-right:1px solid rgb(217 217 217)" class="text-primary">{{$t('msg.충전')}}  </div>
           				<div style="padding:0 3px;">
           					<p class="mb-0" style="border-bottom:1px solid rgb(217 217 217)"><span style="font-size:13px;">{{$t('searchText.요청')}}:</span><span  style="font-size:16px;margin-left:5px;">{{in_sum}}</span></p>
           					<p class="mb-0 text-primary"><span style="font-size:13px;">{{$t('msg.대기')}}:</span><span  style="font-size:16px;margin-left:5px;">{{in_dg}}</span></p>
           				</div>
           			</div>  
           		        			
           		</li>
           		<li class="mr-2"  @click="gotoMoneyout" style="cursor:pointer">
           			
           			<div class="bg-default rounded d-flex align-items-center">
           				<div style="padding:0 3px;border-right:1px solid rgb(217 217 217)" class="text-danger">{{$t('msg.환전')}}  </div>
           				<div style="padding:0 3px;">
           					<p class="mb-0" style="border-bottom:1px solid rgb(217 217 217)"><span style="font-size:13px;">{{$t('searchText.요청')}}:</span><span  style="font-size:16px;margin-left:5px;">{{out_sum}}</span></p>
           					<p class="mb-0 text-danger"><span style="font-size:13px;">{{$t('msg.대기')}}:</span><span  style="font-size:16px;margin-left:5px;">{{out_dg}}</span></p>
           				</div>
           			</div> 
           			
           		</li>
           		<li class="mr-2"  @click="gotoQa" style="cursor:pointer">
           			
           			<div class="bg-default rounded d-flex align-items-center">
           				<div style="border-right:1px solid rgb(217, 217, 217);padding:0 3px;" class="text-success">{{$t('msg.문의')}}  </div>
           				<div style="padding:0 3px;">
           					<p class="mb-0" style="border-bottom:1px solid rgb(217 217 217)"><span style="font-size:13px;">{{$t('searchText.요청')}}:</span><span  style="font-size:16px;margin-left:5px;">{{inq_sum}}</span></p>
           					<p class="mb-0 text-success"><span style="font-size:13px;">{{$t('msg.대기')}}:</span><span  style="font-size:16px;margin-left:5px;">{{inq_dg}}</span></p>
           				</div>
           			</div>   
           		
           		</li>
           		<li class="mr-2"  @click="gotoMemlist" style="cursor:pointer">
           			
           			<div class="bg-default rounded d-flex align-items-center">
           				<div style="border-right:1px solid rgb(217, 217, 217);padding:0 3px;">{{$t('msg.신규')}}</div>
           				<div style="padding:0 3px;">
           					<p class="mb-0" style="border-bottom:1px solid rgb(217 217 217)"><span style="font-size:13px;">{{$t('searchText.요청')}}:</span><span  style="font-size:16px;margin-left:5px;">{{join_sum}}</span></p>
           					<p class="mb-0"><span style="font-size:13px;">{{$t('msg.대기')}}:</span><span  style="font-size:16px;margin-left:5px;">{{join_dg}}</span></p>
           				</div>
           			</div>   
           		
           		</li>

           		
           		
           	

           	</ul></div>
           	<div class="d-flex">
           			<div v-if="this.sitetype=='4'" class="d-flex mt-1250 mb-1250 d-800" >
           			<textarea v-model="textarea" @focus="textAuto" @blur="textAutoBlur" class="textArea mr-2"></textarea><el-button type="default" plain size="mini" style="height:50px;font-size:16px;" class="ml-310 ml-1250" @click="editTextArea">{{$t('msg.수정')}}</el-button></div>

           			<template v-if="this.userid=='admin'">
           				<div class="ml-2 text-white d-flex align-items-center" style="font-size:16px">
           		<span class="mr-2">디도스방어</span>
           		 <el-switch
							  v-model="swithValue"
							  active-color="#13ce66"
							  inactive-color="#d1d1d1" >
							</el-switch>
           		<el-tooltip class="item ml-2" effect="dark" :content="$t('newAdd.방어하시면한국아이피만허용되며방어시스템이작동됩니다')" placement="bottom-start">
											      <el-button icon="el-icon-warning" circle></el-button>
						  </el-tooltip>
						  

           	</div >
           	</template>
           	</div>
           	

           </div>
           <audio id="ttsAudio" ref="ttsAudio"></audio>

			
			<el-menu
			 
			  mode="horizontal"
			  @select="handleSelect"
			  background-color="#384756"
			  text-color="#fff"
			  active-text-color="#ffd04b" style="display: flex;">
			  <el-submenu v-if=" (this.userid=='freedom' || this.userid=='admin' || this.userid=='diamond') && this.sitetype=='4'" index="10">
			  	 <template slot="title">
			  	 	{{$t('msg.언어전환')}}
			  	 </template>
		       
		       <el-menu-item index="10-2">Ko</el-menu-item>
		       <el-menu-item index="10-3">mg</el-menu-item>
		      

		        </el-submenu>
			   <el-menu-item v-if="this.sitetype=='4'">
			   	 <el-switch
				  v-model="swithValue"
				  active-color="#13ce66"
				  inactive-color="#d1d1d1" @change="changeSwith($event)">
				</el-switch>
			   </el-menu-item>
			   <el-submenu index="100">
		        <template slot="title">
		           <el-avatar size="small" 
		           src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
		          {{userid}}
		        </template>
		       <el-menu-item index="100-1">IP차단</el-menu-item>
		       <el-menu-item index="100-2">{{$t('msg.비번수정')}}</el-menu-item>
		        <el-menu-item index="100-3">{{$t('msg.로그아웃')}}</el-menu-item>

		        </el-submenu>

			  
			</el-menu>
		   </div>
           
           

		  </el-header>
		  <el-container style="height: 100%;overflow-y:auto">
		  	 <!-- 侧边布局 -->
		    <el-aside width="180px" style="background:rgb(56, 71, 86);position:relative;" v-if="showAside">
		    	
		    	<el-menu  style="height:100%" :default-active="slideMenusActive" @select="slideSelect"
		    	background-color="#384756"
			  	text-color="#fff"
			  	active-text-color="#ffd04b">
				     
				      <template v-for="(subitem,index) in slideMenus" >

				      <el-menu-item v-if="!subitem.children"   :index="subitem.pathname" style="height:36px;line-height:36px;" :class="subitem.pathname==='inoutzp_list' || subitem.pathname==='racelist_list'|| subitem.pathname==='dcheck_list'|| subitem.pathname==='autoqa_list'|| subitem.pathname==='log_list' ?'border-bottom-1' :''">
				        <i :class="subitem.icon"></i>
				        <span slot="title">{{subitem.name}}</span>
				      </el-menu-item>

				      <el-submenu v-if="subitem.children" :key="subitem.name" :data="subitem" :index="subitem.pathname">
				        <template  slot="title" style="height:36px;line-height:36px;"><div style="background: #2c3844;position: absolute;width: 100%;left:0"><i :class="subitem.icon" style="margin-left:20px"></i>{{subitem.name}}</div></template>
				       <el-menu-item v-for="(childs_menu,index) in subitem.children" :key="childs_menu.name"  :index="childs_menu.pathname" :class="childs_menu.pathname==='betting_list7' ||childs_menu.pathname==='pt_memo_list'||childs_menu.pathname==='pt_money_list' ?'border-bottom-1':''" style="height:36px;line-height:36px;padding-left: 20px;"><i :class="childs_menu.icon"></i>{{childs_menu.name}}</el-menu-item>
				       
				      </el-submenu>


				       </template>

				      
				</el-menu>



		    </el-aside>
		    <el-main class="bg-light" style="position: relative;">
		    	<!-- 主内容 -->
        		<router-view></router-view>

		    </el-main>
		  </el-container>
		</el-container>
		<!--ipDialog-->
		<el-dialog
            :visible.sync="ipDialogVisible" :width="ipWidth" :close-on-click-modal ="false" class="rdp">
            
            <el-table
                :data="ipData"
                style="width: 100%" v-loading="ipLoading">
                <el-table-column
                  prop="ip"
                  :label="$t('tableText.아이피')"
                  align="center">
                </el-table-column>
                 <el-table-column
                  prop="memo"
                  :label="$t('tableText.메모')"
                  align="center">
                </el-table-column>
                 <el-table-column
                  prop="add_time"
                  :label="$t('tableText.추가시간')"
                 align="center">
                </el-table-column>
                 <el-table-column
                  prop="date"
                  :label="$t('tableText.상태')"
                  align="center">
                  <template slot-scope="scope">
                  	<el-button type="primary" plain size="mini" @click="deleteIp(scope)">IP해재</el-button>
                  </template>
                </el-table-column>
               
              
              </el-table>
              <div style="height:10px;clear:both;"></div>
                <el-pagination
					  :current-page="ipcurrentPage"
					  :page-sizes="[30,50,100]"
					  :page-size="this.ipsize"
					  layout="prev, pager, next"
					  :total="iptotal"
					  @size-change="ipSizeChange"
      				  @current-change="ipCurrentChange">
				</el-pagination>
				<el-form ref="form" :model="ipform" label-width="100px" class="ipformItem">
					<table class="table table-bordered myTable mt-3">
                <tr>
                  <td>
                  	 <el-form-item label="IP" class="mb-0">
		              <el-input v-model="ipform.ip" size="mini" class="ml-2 w-75"></el-input>
		            </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td style="height:100px;">
                  	  <el-form-item :label="$t('tableText.원인')" class="mb-0 memo">
		               <el-input
		                type="textarea"
		                :rows="4"
		                v-model="ipform.memo"  size="mini" class="ml-2 mt-2">
		              </el-input>
		          </el-form-item>
                  </td>
                </tr>
                 </table>
            
		           
		           
		          
		          </el-form>

  
            <span slot="footer" class="dialog-footer">
            	<el-button type="primary" @click="ipSubmit" :disabled="disabled">IP차단</el-button>
        
            </span>
          </el-dialog>
          <!-- password -->
            <el-dialog 
          :visible.sync="passDialog"
          :width="pWidth" :close-on-click-modal ="false">

          <el-form ref="passform" :model="passform" label-width="100px" :rules="rules">

          	<el-form-item :label="$t('tableText.현제비번')" class="mb-0" prop="thispass">
              <el-input v-model="passform.thispass"  class="w-75" type="password"></el-input>
            </el-form-item>

            
            <el-form-item :label="$t('nav.비밀번호')" class="mb-0" prop="oldpass">
              <el-input v-model="passform.oldpass"  class="w-75" type="password"></el-input>
            </el-form-item>
             <el-form-item :label="$t('nav.비밀확인')" class="mb-0" prop="newpass">
              <el-input v-model="passform.newpass"  class="w-75" type="password"></el-input>
            </el-form-item>
          <el-form-item label="OTP" class="mb-0">
              <el-input v-model="passform.otp"  class="w-75" type="password"></el-input>
            </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="passDialog = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="passSumbit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>  
           <el-dialog 
          :visible.sync="potDialog"
          :width="potWidth" :close-on-click-modal ="false">

         <el-form inline ref="form" :model="form">
				      <el-form-item class="mb-0 mr-0" :label="$t('msg.알금액')">
				             <el-select v-model="pot"  :placeholder="$t('status.선택')" style="width:120px;">
				               <el-option
				                      v-for="item in potOptions"
				                      :key="item.value"
				                      :label="item.label"
				                      :value="item.value">
				                    </el-option>
				              </el-select>
				          </el-form-item>
				        
				  </el-form>
				  <div class="text-danger">*입금하시고 셀프 알충전기능입니다.</div>
          <span slot="footer" class="dialog-footer">
           
            <el-button type="primary" @click="potConfirm">{{$t('msg.충전')}}</el-button>
          </span>
        
       
       
        </el-dialog> 
		<div class="bottom_msg d-flex" v-if="this.bottom_msg !=''">
        	<div class="">
   					 <span>{{bottom_msg}}</span>
					</div>
						  
		    		<el-button type="danger" @click="msgClose" class="ml-auto">CLOSE</el-button>
					
			 </div>
	</div>

 </template>

 <script>
 import  common from "../components/mixins/common.js"
 import EventBus from '../assets/js/eventBus.js';
  import history from '../components/common/history.vue';
    export default {
    	mixins:[common],
    	data(){
    		return{
    			bottom_msg:'',
    			lang:'ko',
    			moneytitle:'',
    			passform:{
    				oldpass:'',
    				thispass:'',
    				newpass:'',
    				otp:''
    			},
    			potWidth:'300px',
    			pWidth:'400px',
    			potDialog:false,
    			 potOptions:[
             
             {
              label:this.$i18n.t("msg.억알"),
              value:'100000000'
            },
               
           
             {
              label:this.$i18n.t("msg.천만알f"),
              value:'50000000'
            }
            
            ,
            {
              label:this.$i18n.t("msg.천만알t"),
              value:'30000000'
            },{
              label:this.$i18n.t("msg.천만알w"),
              value:'20000000'
            },{
              label:this.$i18n.t("msg.천만알o"),
              value:'10000000'
            }  
            ],
    			 pot:'',
    			passDialog:false,
    			iptotal:0,
    			ipsize:0,
    			apimoney:'',
    				sp_apimoney:'',
    			apiumoney:'0',
    			sitemoney:'',
    			ttmoney:0,
    			ipcurrentPage:1,
    			ipData:[],
    			ipWidth:'600px',
    			disabled:false,
    			showAside:true,
    			ipLoading:false,
    			ipDialogVisible:false,
    			topInfo:true,
    			swithValue:true,
    			textarea:window.sessionStorage.getItem('adminmemo'),
    			menu_name:{
                'memlist_list':this.$i18n.t("nav.회원관리"),
                 'user_list':this.$i18n.t("nav.회원관리"),
                 'bubon_list':this.$i18n.t("nav.부본사관리"),
                 'zp_list':this.$i18n.t("nav.총판관리"),
                 'admin_list':this.$i18n.t("nav.알본관리"),
                 'bon_list':this.$i18n.t("nav.본사관리"),
                 'master_list':this.$i18n.t("nav.마스터관리"),

                 'inout_list':this.$i18n.t("nav.회원별입출금"),
                 'inoutzp_list':this.$i18n.t("nav.총판별입출금"),
                 'race_list':this.$i18n.t("nav.RACE결과"),
                 'buy_list':this.$i18n.t("nav.구매내역RACE"),
                 'racelist_list':this.$i18n.t("nav.RACE리스트"),
                 'money_list':this.$i18n.t("nav.입출금내역"),                
                  'moneybak_list':this.$i18n.t("nav.수동충환내역"),
                 'lossrace_list':this.$i18n.t("nav.손실금RACE"),
                 'moneylogs_list':this.$i18n.t("nav.머니로그"),
                 'moneylogs_list_user':this.$i18n.t("nav.머니로그"),
                 'moneylogs_list_pt':this.$i18n.t("nav.머니로그"),
                 'calculation_list':this.$i18n.t("nav.정산관리"),
                 'dcheck_list':this.$i18n.t("nav.출석체크"),
                 'qa_list':this.$i18n.t("nav.고객센터"),
                  'memo_list':this.$i18n.t("nav.쪽지관리"),
                 'memo_list_user':this.$i18n.t("nav.쪽지관리"),
                 'memo_list_pt':this.$i18n.t("nav.쪽지관리"),
                 'board_list':this.$i18n.t("nav.게시판"),
                 'pop_list':this.$i18n.t("nav.팝업관리"),
                 'autoqa_list':this.$i18n.t("nav.답변관리"),
                 'online_list':this.$i18n.t("nav.접속리스트"),
                 'acclist_list':this.$i18n.t("nav.접속로그"),
                 'betting_list1':this.$i18n.t("nav.배팅내역"),
                 'betting_list2':this.$i18n.t("nav.배팅내역"),
                 'betting_list3':this.$i18n.t("nav.배팅내역"),
                 'betting_list4':this.$i18n.t("nav.배팅내역"),
                 'betting_list5':this.$i18n.t("nav.배팅내역"),
                 'betting_list6':this.$i18n.t("nav.배팅내역"),
                 'betting_list7':this.$i18n.t("nav.배팅내역"),
                 'log_list':this.$i18n.t("nav.종합로그"),
                 'settings_list':this.$i18n.t("nav.사이트설정"),
                 'order_list':this.$i18n.t("nav.구매내역파워볼"),
                 'ordergro_list':this.$i18n.t("nav.구매내역4조합"),
                  'act_list':this.$i18n.t("nav.정산관리"),
                 'sp_list':this.$i18n.t("nav.매장관리"),
                  'powerball_list':this.$i18n.t("nav.파워볼결과"),
                 'sadari_list':this.$i18n.t("nav.사다리결과"),
                 'powerball_bg_list':this.$i18n.t("nav.파워볼결과보글"),
                 'sadari_bg_list':this.$i18n.t("nav.사다리결과보글"),
                 'orderapi_list':this.$i18n.t("nav.API배팅"),
                  'losinglist_list':this.$i18n.t("nav.루징정산"),
                  'alert_list':this.$i18n.t("nav.팝업관리"),
                  'rdp_list':this.$i18n.t("nav.일자별롤링루징"),
                  'dashboard_index':this.$i18n.t("nav.대시보드"),
                   'game_list':this.$i18n.t("nav.게임관리"),
                   'gamesd_list':this.$i18n.t("nav.게임관리"),
                    'gamess_list':this.$i18n.t("nav.게임관리"),
                    'gamesp_list':this.$i18n.t("nav.게임관리"),
                     'gamegd_list':this.$i18n.t("nav.게임관리"),
                      'gamehn_list':this.$i18n.t("nav.게임관리"),
                   'delac_list':this.$i18n.t("nav.삭제관리"),
                   'orderoffer_list':this.$i18n.t("nav.구매내역파워볼"),
                   'jang_list':this.$i18n.t("nav.죽장관리"),
                    'jangnew_list':this.$i18n.t("nav.루징정산"),
                   'coupon_list':this.$i18n.t("newAdd.쿠폰관리"),
                    'calculation_new_list':this.$i18n.t("nav.정산관리"),
                     'settings_edit_list':this.$i18n.t("nav.사이트설정"),
                      'gamespnew_list':'게임관리(오라클)',
                       'rolling_c_list':this.$i18n.t("msg.롤링전환"),

                },
    			
    			ipform:{
    				ip:'',
    				memo:''
    			},
    			form:{
    				mem_id:'',
    				money:'',
    				memo:'',
    			},
    			newlist:[],
    			dsq:null,
    			domain:window.sessionStorage.getItem('domain'),
          site:window.sessionStorage.getItem('site'),
          sitetype:window.sessionStorage.getItem('sitetype'),
    			outbet:window.sessionStorage.getItem('outbet'),
    			grobet:window.sessionStorage.getItem('grobet'),
    			bg:window.sessionStorage.getItem('bg'),
    			userid:window.sessionStorage.getItem('userid'),
    			aid:window.sessionStorage.getItem('admin_id'),
    			power:window.sessionStorage.getItem('power'),
    			api_type:window.sessionStorage.getItem('api_type'),
    			sim:window.sessionStorage.getItem('sim'),
    			pasing:window.sessionStorage.getItem('pasing'),
    			loading:false,
    			in_dg:'0',
    			in_sum:'0',
    			join_dg:'0',
    			join_sum:'0',
    			inq_dg:'0',
    			inq_sum:'0',
    			out_dg:'0',
    			out_sum:'0',
    			int1:'0',
    			int2:'0',
    			int3:'0',
    			int33:'0',
    			int4:'0',
    			int44:'0',
    			int5:'0',
    			int6:'0',
    			int7:'0',
    			int8:'0',
    			int9:'0',
    			int88:'0',
    			int99:'0',
    				totalmoney:'0',
    					totalemoney:'0',
               
        		navBars:[],
        		rules: {
                  oldpass:[{ required: true, message: '', trigger: 'blur'}],
                  newpass:[{ required: true, message: '', trigger: 'blur'}],
                  thispass:[{ required: true, message: '', trigger: 'blur'}],
              }
        		
        	}
    	},
    	created(){
        //console.log('lang',this.lang)
    		let token=window.sessionStorage.getItem('user');
    		if(token==null)
    		{
               this.$router.push({name:'login'})
               return;
    		}



    		let vv=localStorage.getItem('topInfo')
               
    			if(vv==0){
    				this.topInfo = false
    				this.swithValue=false
    				
    			}else{
    				this.topInfo = true
    				this.swithValue=true
    				
    			}

    		this.moneytitle='알잔액';

    		if(this.userid!='admin')
    		{
            this.moneytitle='알잔액';
    		}

    		
    		this.getStatus();
    		
    		if(this.sitetype=='4')
    		{
    			this.getApiInfo();
          this.getAdminMemo();
    		}

    		let language=window.sessionStorage.getItem('lang');
    		if(language)
    		{
           this.lang=language
    		}

    		if(this.lang=='en'){
    			this.navBars = this.$confEn.navBars
    		}
        else if(this.lang=='mg')
        {
           this.navBars = this.$confMg.navBars
        }
    		else{
    			this.navBars = this.$conf.navBars
    		}

    		this.$i18n.locale = this.lang;
    		
    		// var instanceNotification = Notification || window.Notification;
        // console.log('instanceNotification',instanceNotification);
    

    		// 初始化选中菜单
			this.__initNavBar()
			
			let that=this

			const timer = window.setInterval(()=>{
	           this.getStatus()
            }, 20000)
            
            this.$once('hook:beforeDestroy', function () {
               window.clearInterval(timer)
            })


            let menulist = this.navBars.list[0].submenu;

            menulist.forEach(item=>{

            	  if(item.type==that.userid)
            	  {
                  that.newlist.push(item);
            	  }
            
                if(that.sitetype=='3')
                {
                   if(item.type!='evo')
                   {
                   	if(item.type=='pp_out')
                	 {
                		if(that.outbet=='1')
                		{
                           that.newlist.push(item);
                		}
                        
                	}

                	if(item.type=='ppgro')
                	{
                		if(that.grobet=='1')
                		{
                           that.newlist.push(item);
                		}
                        
                	}

                    if(item.type=='all' || item.type=='power' || item.type=='pp')
                	{
                        that.newlist.push(item);
                	}
                   }

                   if(item.type=='race')
                	{
                        that.newlist.push(item);
                	}


                  
                }
                else if(that.sitetype=='1')
                {
                	if(item.type=='all' || item.type=='power' || item.type=='pp')
                	{
                		    if( ( that.domain=="https://eos.bd7080.com" || that.domain=="https://jst.bd7080.com") && item.pathname=="moneybak_list")
                		    {

                		    }else
                		    {
                		    	  that.newlist.push(item);
                		    }
                        
                	}

                	if(item.type=='pp_out')
                	{
                		if(that.outbet=='1')
                		{
                           that.newlist.push(item);
                		}
                        
                	}

                	if(item.type=='pp3')
                	{
                		if(that.bg=='1')
                		{
                           that.newlist.push(item);
                		}
                        
                	}

                	if(item.type=='ppgro')
                	{
                		if(that.grobet=='1')
                		{
                           that.newlist.push(item);
                		}
                        
                	}
                    
                }
                else if(that.sitetype=='2')
                {
                	if(item.type=='all' || item.type=='race')
                	{
                        that.newlist.push(item);
                	}
                	if(item.type=='power' && that.power=='1')
                	{
                       that.newlist.push(item);
                	}
                    
                }else if(that.sitetype=='4')
                {
                	if(item.type=='all' || item.type=='power' || item.type=='evo')
                	{
                		 if(that.userid=='admin')
                		 {
                        that.newlist.push(item);  
                		 }else
                		 {
                		 	  if(!item.admin)
                		 	  {
                		 	  	 if(item.pathname=='order_list' || item.pathname=='powerball_list')
                		 	  	 { 
                              if(that.power=='1')
                              {
                                  that.newlist.push(item);  
                              }  
                		 	  	 }
                		 	  	 else if(item.pathname=='bon_list' || item.pathname=='master_list')
                		 	  	 {
                               if(that.userid=='soft12' || that.userid=='soft20' || that.userid=='soft09' || that.userid=='soft22' ||  that.userid=='soft23' || that.userid=='soft19' || that.userid=='soft16' || that.userid=='soft03' || that.userid=='soft07' || that.userid=='soft05' || that.userid=='admin' || that.userid=='testbon' || that.userid=='soft13' || that.userid=='soft10' || that.userid=='soft25' || that.userid=='soft18' || that.userid=='soft17' || that.userid=='soft08')
                              {
                                  that.newlist.push(item);  
                              } 
                		 	  	 }
                		 	  	 else if(item.pathname=='coupon_list')
                		 	  	 {
                              if(that.userid=='soft20' || that.userid=='soft16' || that.userid=='soft22' || that.userid=='testbon' || that.userid=='bon' || that.userid=='soft10' || that.userid=='soft19' || that.userid=='soft25' || that.userid=='soft26' || that.userid=='soft18')
                              {
                                  that.newlist.push(item);  
                              } 
                		 	  	 }
                		 	  	 else if(item.pathname=='jangnew_list')
                		 	  	 {
                              //if(that.userid=='soft16' || that.userid=='testbon' || that.userid=='soft25' || that.userid=='soft19' || that.userid=='admin')
                              //{
                                 // that.newlist.push(item);  
                              //} 
                		 	  	 }
                		 	  	 else if(item.pathname=='jang_list')
                		 	  	 {
                              if(that.userid!='soft19')
                              {
                                  that.newlist.push(item);  
                              } 
                		 	  	 }
                		 	  	 else if(item.pathname=='gamesd_list')
                		 	  	 {
                              if(that.api_type=='sd')
                              {
                                  that.newlist.push(item);  
                              } 
                		 	  	 }
                		 	  	 else if(item.pathname=='gamesp_list')
                		 	  	 {
                              if(that.api_type=='sp')
                              {
                                  that.newlist.push(item);  
                              } 
                		 	  	 }
                		 	  	 else if(item.pathname=='gamehn_list')
                		 	  	 {
                              //if(that.api_type=='hn')
                              //{
                                  that.newlist.push(item);  
                              //} 
                		 	  	 }
                		 	  	 else
                		 	  	 {
                		 	  	 	  that.newlist.push(item);  
                		 	  	 }
                           
                		 	  }
                		 	  
                		 }

                    }
                   else if(item.type=='pp_out')
                	 {
                		if(that.userid=='admin' || that.outbet=='1')
                		{
                           that.newlist.push(item);
                		}
                        
                	}
                }
                
           });

           //console.log('that.newlist',that.newlist)
				


    	},
    	watch: {


			/*'$route'(to, from) {
				// 本地存储
				localStorage.setItem('navActive',JSON.stringify({
					top:this.navBars.active || '0',
					left:this.slideMenusActive || '0'
				}))
				
			}*/
		},
    	computed:{


    		/*slideMenusActive:{
    			get(){

    				return this.navBars.list[this.navBars.active].subActive || '0'
    			},
    			set(val){
    				return this.navBars.list[this.navBars.active].subActive = val


    			},
    			
    		},*/
    		slideMenus(){
    			return this.newlist

    		},

    	},
    	methods: {

    		 async play(v, title = '알림', body = '새로운 요청이 있습니다') {

    		 	console.log('v',v);

    		 	  // ✅ 先弹通知（立即提示）
  this.showBrowserNotification(title, body);

    // 右下角提示
 // this.showToastNotification(title, body);

    const audio = this.$refs.ttsAudio || document.getElementById('ttsAudio');

    try {
      audio.muted = false;
      audio.volume = 1;
      audio.src = v;

      await audio.play();
    } catch (e) {
      console.warn('声音播放失败，改用浏览器通知', e);
      this.showBrowserNotification(title, body);
    }
  },

  showBrowserNotification(title, body) {
  if (!('Notification' in window)) {
    this.$message.warning(body);
    return;
  }

  if (Notification.permission === 'granted') {
    new Notification(title, {
      body: body,
      icon: '/favicon.ico'
    });
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        new Notification(title, {
          body: body,
          icon: '/favicon.ico'
        });
      }
    });
  } else {
    // 被拒绝时 fallback
    this.$message.warning(body);
  }
},
    		msgClose(){
    			this.bottom_msg = ''
    		},
    		showNav(){
			      	this.showAside = !this.showAside

			      },
    		 ipSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.ipsize = val
			        this.getIpData();
			        this.ipLoading= true

			      },
			   potEvent(){
    			this.potDialog = true
    		},
			  ipCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.ipcurrentPage = val
			        this.getIpData();
			        this.ipLoading= true
			      },
    	getIpData(){
    	   
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/blist?page='+this.ipcurrentPage+'&limit='+this.ipsize;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('ipdata=',response)
                     let data = response.data.data
                     this.ipData =data.data
                     this.iptotal = data.total
                     this.ipcurrentPage = data.current_page
                     this.ipsize =data.per_page
                     this.ipLoading = false

                   
               
            }).catch((error) =>{
             
                console.log('error',error.response)       //请求失败返回的数据
               
            })
        },

    		changeSwith(val){
    			console.log('val',val)
                //let vv=localStorage.getItem('topInfo')
                //console.log('vv',vv)
    			if(val===false){
    				this.topInfo = false
    				localStorage.setItem('topInfo',0)
    			}else{
    				this.topInfo = true
    				localStorage.setItem('topInfo',1)
    			}

    			
    		},
    		textAuto(e){
    			let o = e.target;
                 o.style.height = o.scrollTop + o.scrollHeight + "px";

    		},
    		textAutoBlur(e){
    			let o = e.target;
                 o.style.height = 50 + "px";

    		},
    		editTextArea(){
    				 this.$confirm(this.$i18n.t("msg.수정하시겠습니까"), this.$i18n.t("msg.알림"), {
    			 	confirmButtonText: this.$i18n.t("msg.수정"),
         		 cancelButtonText: this.$i18n.t("msg.취소"),
			          type: 'warning'
			        }).then(() => {

			        	let token=window.sessionStorage.getItem('user');
			    		if(token==null)
			    		{
			               this.$router.push({name:'login'})
			               return;
			    		}
			        	

			        	this.$axios({
		                  method:'post',
		                  url:this.domain+'/admin/adminmemo_up',
		                  data:{
		                  	id:1,
		                  	content:this.textarea
		                  },
		                  'Accept': 'application/json',
		                   headers: { 'Authorization': 'Bearer ' + token },
	    
			             }).then((response) =>{
			             	if(response.data.code==200)
			             	{
                                 this.$message.success(response.data.msg);
			             	}else
			             	{
                                 this.$message.error(response.data.msg);
			             	}

			             }).catch((error) =>{

			             })
                                
       

			          }).catch(() => {
					          this.$message({
					            type: 'info',
					            message: this.$i18n.t("msg.취소됨")
					          });          
					        });

    		},
    		 history(){

            if(this.userid!='admin')
            {
return;
            }

              this.$layer.iframe({
            type: 2,
            title: this.$i18n.t("searchText.히스토리"),
            content: {
                content: history,
                parent: this,
                data:{
               
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['1000px', '680px'],
         
        });
        },
    		
    		/* play(v) {
    		 	//在这给音频 赋值 地址
			    //  this.$refs.audio.src("test.mp3");
			      //this.$refs.audio.play();

			      console.log('vvv',v);

			      var ttsAudio = document.getElementById('ttsAudio');
            ttsAudio.src=""+v;
			      ttsAudio.play();
			    },*/
    		openDialog(){
    			this.dialogModel = true
    			
    		},
    		 potConfirm(){
               let token=window.sessionStorage.getItem('user');

               this.$axios({
                    method:'post',
                    url:this.domain+'/admin/pot_add',
                    data:{
                       pot:this.pot
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                         
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
    		getStatus(){
    			let token=window.sessionStorage.getItem('user'); 
    			let sound=window.sessionStorage.getItem('sound');

    			let inss='';
          let outss='';
          let joinss='';
          let qass='';

    			let slist=sound.split('-');
    			//console.log('slist',slist);
    			if(slist.length==4)
    			{
              inss=slist[0];
              outss=slist[1]; 
              joinss=slist[2]; 
              qass=slist[3]; 

    			}else
    			{
    				  slist=sound.split('|');
    				  inss=slist[0];
              outss=slist[1]; 
              joinss=slist[2]; 
              qass=slist[3];
    			}
    		 
    			

    			if(token)
    			{
                  this.$axios({
                  method:'post',
                  url:this.domain+'/admin/process',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
		    
		            }).then((response) =>{ 


		            	
		          let data = response.data.data
							EventBus.$on('sendByBus',data => {
							    			
							    		console.log('sendByBus:===',data)
							    		this.apimoney = data*1

							    		})
		            
		          this.in_dg=data.in_dg
							this.in_sum=data.in_sum
							this.inq_dg = data.inq_dg
							this.inq_sum = data.inq_sum
							this.out_dg = data.out_dg
							this.out_sum = data.out_sum
							this.join_dg = data.join_dg
							this.join_sum = data.join_sum
							this.int1 = data.int1
							this.int2 = data.int2
							this.int3 = data.int3
							this.int4 = data.int4
							this.int33 = data.int33
							this.int44 = data.int44
							this.int5 = data.int5
							this.int6 = data.int6
							this.int7 = data.int7
							this.int8 = data.int8
							this.int9 = data.int9
							this.int88 = data.int88
							this.int99 = data.int99
							this.totalmoney=data.totalmoney
							this.totalemoney=data.totalemoney
							this.bottom_msg=data.bottom_msg
							

							//调用播放声音


							
								  if (this.in_dg && inss != '') {
  this.play(inss, '입금 알림', '입금 대기 요청이 있습니다')
} else if (this.out_dg && outss != '') {
  this.play(outss, '출금 알림', '출금 대기 요청이 있습니다')
} else if (this.inq_dg && qass != '') {
	console.log('문의 알림')
  this.play(qass, '문의 알림', '문의 대기 요청이 있습니다')
} else if (this.join_dg && joinss != '') {
  this.play(joinss, '신규회원 알림', '신규회원 가입 요청이 있습니다')
}


  //this.play(qass, '문의 알림', '문의 대기 요청이 있습니다')
							
                  }).catch((error) =>{  

		                	if(error.response.status==401)
		                	{
		                		  window.sessionStorage.clear();
                          this.$router.push({name:'login'})
		                	}

		                 console.log('eee',error.response.status);
		               })
		    	}
                

    		},
    		showToastNotification(title, body, type = 'warning') {
  this.$notify({
    title: title,
    message: body,
    type: type,
    position: 'bottom-right',
    duration: 5000,
    offset: 80
  });
},
    		creatNotification(){
    			
    		},
    		setPermission(){
    			console.log(setPermission)
    		},
    		getAdminMemo(){
    			let token=window.sessionStorage.getItem('user'); 
    			

    			if(token)
    			{
                  this.$axios({
                  method:'get',
                  url:this.domain+'/admin/getadminmemo?id=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
		    
		            }).then((response) =>{ 
		              let data = response.data.data
		              if(data!=this.textarea)
		              {
                         window.sessionStorage.setItem('adminmemo',data)
                         this.textarea=data
                         //console.log('5')
		              }             
		                
		              }).catch((error) =>{  
		              })
		    	}
                

    		},
    			getApiInfo(){
    			let token=window.sessionStorage.getItem('user'); 
    			

    			if(token)
    			{
                  this.$axios({
                  method:'get',
                  url:this.domain+'/admin/api_info?id=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
		    
		            }).then((response) =>{ 
		              let data = response.data.data
		              if(response.data.code==200)
		              {
		              	  if(this.userid=='admin')
		              	  {
                         this.apimoney=data.balance
                         this.apiumoney=data.user_balance
                         this.sitemoney=response.data.sitemoney
		              	  }else
		              	  {
		              	  	 this.apimoney=data.balance
		              	  	 if (typeof(data.sp_apimoney) === 'undefined') {
		              	  	   
		              	  	 }else
		              	  	 {
		              	  	 	 this.sp_apimoney=data.sp_apimoney
		              	  	 }
                         this.apiumoney=data.user_balance
                         this.sitemoney=response.data.sitemoney
		              	  }
		              	  this.ttmoney=data.total_money
                      
		              }else
		              {

		              }
		              
		              }).catch((error) =>{  
		              })
		    	}
                

    		},
    	  __initNavBar(){
    	  
			let r = localStorage.getItem('navActive')  
			//console.log(r)
			
			if (r) {
				r = JSON.parse(r)
				this.navBars.active = r.top
				this.slideMenusActive = r.left
			}
		  },	
	      handleSelect(key, keyPath) {
	        
	        let that=this;
	        this.navBars.active = key
	        
	         if(key === '10-1'){
	        	
	        	this.$confirm('Are you sure to switch languages?', 'Tip', {
							       confirmButtonText: 'OK',
							       cancelButtonText: 'Cancel',
							       type: 'warning'
							    }).then(() => {
							       if ( this.lang === 'ko' ||  this.lang === 'mg') {
							          this.lang = 'en';
							          this.$i18n.locale = this.lang;

							          window.sessionStorage.setItem('lang','en')
							          this.$router.replace('/refresh')

							       }
							    }).catch(() => {
							       this.$message({
							           type: 'info',
							           message:'Cancel'
							       });          
							    });
	        }
	         if(key === '10-2'){
	        	this.$confirm('언어를 전환하시겠습니까?', '알림', {
							       confirmButtonText: '확인',
							       cancelButtonText: '취소',
							       type: 'warning'
							    }).then(() => {
							       if ( this.lang === 'en' ||  this.lang === 'mg') {
							          this.lang = 'ko';
							          this.$i18n.locale = this.lang;
							          window.sessionStorage.setItem('lang','ko')
							          this.$router.replace('/refresh')
							       }
							    }).catch(() => {
							       this.$message({
							           type: 'info',
							            message:'취소'
							       });          
							    });
	        }
	        if(key === '10-3'){
	        	this.$confirm('Та хэлээ солимоор байна уу?', 'мэдэгдэл', {
							       confirmButtonText: 'Баталгаажуулах',
							       cancelButtonText: 'Cancel',
							       type: 'warning'
							    }).then(() => {
							       if ( this.lang === 'en' ||  this.lang === 'ko') {
							          this.lang = 'mg';
							          this.$i18n.locale = 'mg';
							          window.sessionStorage.setItem('lang','mg')
							          this.$router.replace('/refresh')
							       }
							    }).catch(() => {
							       this.$message({
							           type: 'info',
							            message:'цуцлах'
							       });          
							    });
	        }
	        if(key === '100-1'){
	        	this.ipDialogVisible=true
    	   		this.ipLoading = true
    	   		this.getIpData()
	        }
	         if(key === '100-2'){
	        	this.passDialog=true
	        }
	        if(key === '100-3'){
	        	 window.sessionStorage.clear();
	           document.title='';
	           //window.localStorage.clear();
             localStorage.setItem('navActive',JSON.stringify({
					   top:'0',
					   left:'memlist_list'
				     }))
				     this.$router.push({name:'login'})
	        }
	      },
	     
	       slideSelect(key,indexPath){

	       	

	       	document.title=this.site+':'+this.menu_name[key];

	       	//return;

	      	this.$router.push({
	      		name:key,
	      		query: {
                 t: +new Date() // 保证每次点击路由的query项都是不一样的，确保会重新刷新view
                }
	      	})


	      	 if(this.slideMenusActive==key)
		      {
		      	  //同一个菜单点击
		      	  this.$router.replace({
		          path: '/redirect',
		          query: {
		            path: key
		          }
		        })
		      }

	     
	      	 this.slideMenusActive = key
		     localStorage.setItem('navActive',JSON.stringify({
						top:'0',
						left:key
					}))


	      },
	      ipSubmit(){
	      	let token=window.sessionStorage.getItem('user');
	      	this.ipLoading = true
	      	this.disabled = true
	      	this.$axios({
                      method:'post',
                      url:this.domain+'/admin/b_insert',
                      data:{
                          ip:this.ipform.ip,
                          memo:this.ipform.memo,
                           
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                      
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.getIpData()  
                      this.ipform.ip=''
                      this.ipform.memo='';
                      this.ipLoading = false,
                      this.disabled = false
                    }else
                    {
                     
                       this.$message({
                          message:response.data.msg,
                          type:'warning'
                      })

                       this.ipLoading = false,
                       this.disabled = false
                    }
                    
                   
                  }).catch((error) =>{
                      this.ipLoading = false
                      this.disabled = false

                      this.$message({
                          message:error,
                          type:'warning'
                      })
                  })
	      },
	      gotoMoney(){
	      	this.$router.push({name:'moneyadd_list'})
	      	//this.slideMenusActive = 'money_list'
	      	document.title=this.$i18n.t("nav.입금내역");

	      	localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'money_list'
                    }))

	      	this.$router.replace('/refresh')

	      },
	       goOnline(){
	      	this.$router.push({name:'online_list'})
	      

	      	localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'online_list'
                    }))

	      	document.title=this.$i18n.t("nav.접속리스트");
	      	this.$router.replace('/refresh')

	      },
	        gotoMoneyout(){
	      	this.$router.push({name:'moneyout_list'})
	      	//this.slideMenusActive = 'money_list'

	      	localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'money_list'
                    }))

	      	document.title=this.$i18n.t("nav.출금내역");
	      	this.$router.replace('/refresh')

	      },
	        gotoQa(){
	      	this.$router.push({name:'qa_list'})

	      	localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'qa_list'
                    }))
	      	//this.slideMenusActive = 'qa_list'
	      	document.title=this.$i18n.t("nav.고객센터");
	      	this.$router.replace('/refresh')

	      },
	      gotoMemlist(){
	      	this.$router.push({name:'memlist_list'})

	      	localStorage.setItem('navActive',JSON.stringify({
                      top:'0',
                      left:'memlist_list'
                    }))
	      	//this.slideMenusActive = 'qa_list'
	      	document.title=this.$i18n.t("nav.회원관리");
	      	this.$router.replace('/refresh')

	      },
	       passSumbit(){
              let token=window.sessionStorage.getItem('user');
               if(this.passform.newpass !== this.passform.oldpass)
              {
                 this.$message({
                    message:this.$i18n.t("msg.비번이일치하지않습니다"),
                    type: 'warning'
                  });
                  return;
              }
              this.$refs.passform.validate((e)=>{
             if(!e) return;
              this.$axios({
                    method:'post',
                    url:this.domain+'/admin/admin_pwd_up',
                    data:{
                      pwd:this.passform.newpass,
                      tpwd:this.passform.thispass,
                     
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 

                    if(response.data.code==200){

                       this.passDialog = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })

                         window.sessionStorage.clear();
                         this.$router.push({name:'login'})
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
    
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })

             })
             
        },
	        // 删除
      deleteIp(e){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText:this.$i18n.t("msg.삭제"),
          cancelButtonText:this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');
          this.ipLoading = true
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/b_up?bidx='+e.row.bidx,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                     this.ipLoading = false
                    
                    this.getIpData()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });

        
      },  
    }
  }
</script>

 <style scoped>
 >>>.el-menu{
 	border-right:none;
 }
 	.close{
 		background: rgba(0, 0, 0, .8);
 		width: 30px;
 		height: 30px;
 		line-height: 30px;
 		border-radius: 100%;
 		text-align: center;
 	}
 	.close i{
 		color: #fff;
 		font-size: 16px;
 	}
 	.myTable .table td,.myTable  .table th{
 		padding: 0;
 		border: none;
 	
 	}
 	.myTable .table-dark{
 		background-color: #404d5a;
 	}
 	.textArea{
 		padding: 10px;
 		height: 50px;
    width: 300px;
    position: absolute;
    z-index: 200; 
        border: none;

 	}
 	.myTable .table td.border-r{
 	border-right:1px solid #747474;
 }
 .myTable .table td.border-b,.myTable .table th.border-b{
 	border-bottom:1px solid #747474;
 }
 .myTable .table td.border-l,.myTable .table th.border-l{
 	border-left:1px solid #747474;
 }
 .myTable .table td.border-t,.myTable .table th.border-t{
 	border-top:1px solid #747474;
 }
 .myTable .table td.pl-10{
 	padding-left:10px;
 }
 	.ml-310{
 		margin-left: 310px;
 	}
.bg-default{
	background-color: #f3f3f3;
}
>>> .rdp .el-dialog__body{
	padding-bottom: 0;
}
>>> .el-header{
	padding: 0;
}
 >>>.el-menu--horizontal>.el-submenu .el-submenu__title,>>>.el-menu.el-menu--horizontal{
        	border-bottom: none;
        }
 .absolute{position:absolute;}
 .display{
 	display:none
 }
   @media (min-width: 1570px){
        .myTable .table{
        	width: 65%;

        }
     
    }
     @media (max-width:1200px){
       .d-1250{
        
       }
       .mt-1250{margin-top: 5px}
       .textArea {width: 200px}
       .ml-1250{margin-left: 205px}
     
    }
    @media screen and (max-width:1000px){
       .d-800{
       	display:none !important;

       }
       .display{
       	display:block;
       }
     
    }

    .scroll-div table{
    min-width:1440px
    }
     .scroll-div table tr td,.scroll-div table tr th{
    	white-space:nowrap;
    } 
    >>>.el-button.is-circle{
    	padding: 3px;
    background: transparent;
    border: none;
    color: #fff;font-size: 16px !important;
    }
    .bottom_msg{
    align-items: center;
    bottom: 10%;
    width: 60%;
    padding: 10px;
    background:rgba(0, 0, 0, .8);
    border-radius: 5px;
 
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #fff;
    width: 60%;
    position: fixed;
    z-index: 9997;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0 auto;
 }
</style>



// WEBPACK FOOTER //
// src/views/layout.vue